import createCachedSelector from 're-reselect';
import { createSelector } from 'reselect';

import { LangUtils } from '../../service/Lang/Lang';
import { RegionsHelpers } from '../../service/RegionsHelpers/RegionsHelpers';
import { getDefaultRegionsTransformEditorState } from '../../service/RegionsTransformEditorHelper/RegionsTransformEditorHelper';
import { Region } from '../../typings/common';
import { GdGeotreeType } from '../../typings/graphql-grid';
import { RegionsTransformEditorsState, RegionsTransformEditorState } from '../../typings/regionsTransformEditor';
import { Regions, State } from '../../typings/state';

export const selectRegionsTransformEditorValue = createCachedSelector(
    (state: State) => state.regionsTransformEditor,
    (state: State, editorId: string) => editorId,
    (editors: RegionsTransformEditorsState, editorId: string): RegionsTransformEditorState => {
        return editors[editorId] || getDefaultRegionsTransformEditorState();
    }
)((state: State, editorId: string) => editorId);

export const selectRegionTreeForTransformEditor = createSelector(
    (state: State) => state.commonData.regions,
    (state: State) => state.commonData.client.translocalGeotreeType,
    (regions?: Regions, translocalGeotreeType?: GdGeotreeType): Region[] | undefined => {
        return regions
            ? RegionsHelpers.getRegionsTree(regions, LangUtils.getCurrentLang(), translocalGeotreeType)
            : undefined;
    }
);

export const selectRegionTreeForTransformEditorByType = createSelector(
    (state: State, geoTreeType: GdGeotreeType | undefined) => geoTreeType,
    (state: State) => state.commonData.regions,
    (geoTreeType?: GdGeotreeType, regions?: Regions): Region[] | undefined => {
        return regions ? RegionsHelpers.getRegionsTree(regions, LangUtils.getCurrentLang(), geoTreeType) : undefined;
    }
);
